export const PARTNER_REF_REGEX = /^[A-Za-z0-9]{8}$/
const COOKIE_NAME = 'ref'
const STORAGE_KEY = 'partnerRef'

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const match = document.cookie.split(';').map((s) => s.trim()).find((s) => s.startsWith(`${name}=`))
  if (!match) return undefined
  // decodeURIComponent throws on malformed percent-encodings (e.g. `ref=foo%ZZ`).
  // Falling back to undefined keeps the resolver fall-through chain alive
  // instead of crashing the register page.
  try {
    return decodeURIComponent(match.slice(name.length + 1))
  } catch {
    return undefined
  }
}

function readQuery(url: string): string | undefined {
  try {
    const u = new URL(url)
    const v = u.searchParams.get(COOKIE_NAME)
    return v ?? undefined
  } catch {
    return undefined
  }
}

function readStorage(): string | undefined {
  if (typeof localStorage === 'undefined') return undefined
  return localStorage.getItem(STORAGE_KEY) ?? undefined
}

function valid(v: string | undefined): string | undefined {
  return v && PARTNER_REF_REGEX.test(v) ? v : undefined
}

export function resolvePartnerRef(opts?: { url?: string }): string | undefined {
  const url = opts?.url ?? (typeof window !== 'undefined' ? window.location.href : '')
  return valid(readCookie(COOKIE_NAME)) ?? valid(readQuery(url)) ?? valid(readStorage())
}

export function persistPartnerRefFromUrl(): void {
  if (typeof window === 'undefined') return
  const fromQuery = valid(readQuery(window.location.href))
  if (fromQuery) localStorage.setItem(STORAGE_KEY, fromQuery)
}
